import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

const { app } = window;

const formConfig = {
	"btnText": {
		"exec": "ログイン",
		"reset": ""
	},
	"dataParams": {
		"uid": {
			"name": "ログインID",
			"inpType": "text",
			"required": true,
			"inpSize": "f"
		},
		"pw": {
			"name": "パスワード",
			"inpType": "password",
			"required": true,
			"inpSize": "f"
		}
	},
	"sheet": {
		"inputs": {
			"dataParams": ["uid", "pw"]
		}
	},
	"form": {
		"requiredText": "",
		"inpsStyle": "grid"
	}
};

// [loginSection] VuwFade
// ログインフォームを持つコンポーネント
vuwer.add("loginSection", {
	vuwType: "fade",
	
	selector() {
		return $("<div/>").addClass("section vuw-fade").attr({
			"id": "login_section",
			"data-section": "login",
			"data-visible": "0"
		}).appendTo( vuwer.get("pageMain").$self );
	},
	
	onReady($self) {
		this.$content = $("<div/>").addClass("content").appendTo($self);
	}
}, function() {
	this
	// [add child Vuw]
	.add("fm", {
		vuwType: "jbForm",
		selector() {
			return $("<form/>").addClass("fm fm-login").attr("id", "fm_login").appendTo(
				this.container.$content
			);
		},
		app,
		ACTION_URL: `${app.config.apipath}/auth`,
		inputIdPrefix: "auth",
		confirmSheetName: false,	// 確認シートなし
		finishSheetName: false,	// 完了シートなし
		autoInit: false,
		
		errorCallbacks: {
			LOGIN(messages, methodName, errcode, errtype) {
				if( Array.isArray(messages) ) {
					return this.alert(messages.join("<br>") || "認証エラー");
				} else {
					return this.errorCallbacks.def.apply(this, arguments);
				}
			}
		},
		
		/**
		 * submit成功コールバック
		 * @param {Object} [config]
		 * @param {Object} res
		 * @returns Promise
		 */
		async onSubmitSuccess(config, res) {
			u_.isObject(res.config) && Object.assign(this.app.config, res.config);
			
			if(res.nextToken) {
				this.app.storage.set("nextToken", res.nextToken);
			}
			
			if( u_.isFunction(this.app.onLoggedIn) ) {
				await Promise.all([this.app.onLoggedIn(res)]);
			}
			
			if( this.app.isWaitingLogin() ) {
				// 処理中だった場合は元の状態に戻す
				await this.app.releaseWaitingLogin();
				
			} else {
				// 初回
				const literal = /login$/;
				this.app.URL = this.app.URL.replace(literal, "");
				this.app.currentPath = this.app.currentPath.replace(literal, "");
				
				const startState = { ...app._GET };
				u_.hasProperty(startState, "sheet") && (delete startState.sheet);
				
				// 初期状態をvuwerへ反映
				await vuwer.setState(startState);
			}
			
			return this.clearVal();
		},
		
		onReady($self) {
			// Enterキーでsubmit可能にする
			$self.off(".killEnterSubmit").on( "keypress", "input", e => {
				if(e.keyCode === 13) {
					// focus中の入力欄にsetValを実行させるため、changeイベントをトリガー
					$(e.currentTarget).trigger("change");
					// .btn-nextのクリックをトリガーし、aSubmitを実行
					const $btn = this.getActiveSheet().$btns.children(".btn-next");
					setTimeout(() => $btn.trigger("click"), 0);
					return false;
				}
			});
			
			this.initForm();
		}
	}, function() {
		// config
		this.setConfig(formConfig);
		
		// appから直接アクセス可能にする
		app.fm.login = this;
	});
});
